import { Panel } from "@xyflow/react";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { useArchViz } from "./ArchVizContext";

function SegButton({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={active}
      className={cn(
        "px-2.5 py-0.5 rounded text-xs font-medium transition-colors duration-base ease-out-soft",
        active
          ? "bg-brand-50 text-ink-heading"
          : "text-ink-muted hover:bg-surface-tint hover:text-ink",
      )}
    >
      {children}
    </button>
  );
}

export function DataViewSwitch() {
  const { state, dispatch } = useArchViz();
  const container = state.selectedContainerId
    ? state.architecture?.containers.find((c) => c.id === state.selectedContainerId)
    : null;

  const show = state.drillLevel === 3 && container != null && Boolean(container.dataModel);
  if (!show) return null;

  return (
    <Panel position="top-left" className="flex items-center gap-2">
      <div className="inline-flex rounded-md border p-0.5 bg-card/90 backdrop-blur shadow-sm">
        <SegButton
          active={state.dataView === "components"}
          onClick={() => dispatch({ type: "SET_DATA_VIEW", view: "components" })}
        >
          Components
        </SegButton>
        <SegButton
          active={state.dataView === "dataModel"}
          onClick={() => dispatch({ type: "SET_DATA_VIEW", view: "dataModel" })}
        >
          Data Model
        </SegButton>
      </div>
      {state.dataView === "dataModel" && (
        <div className="inline-flex rounded-md border p-0.5 bg-card/90 backdrop-blur shadow-sm">
          <SegButton
            active={state.dataModelDensity === "simple"}
            onClick={() => dispatch({ type: "SET_DATA_MODEL_DENSITY", density: "simple" })}
          >
            Simple
          </SegButton>
          <SegButton
            active={state.dataModelDensity === "detailed"}
            onClick={() => dispatch({ type: "SET_DATA_MODEL_DENSITY", density: "detailed" })}
          >
            Detailed
          </SegButton>
        </div>
      )}
    </Panel>
  );
}
